import { FC, useState } from "react"
import { UserDetails } from "../../../types"
import MyAccountInfo from "./sections/MyAccountInfo"
import PasswordForm from "./sections/PasswordForm"
import OtherInfo from "./sections/OtherInfo"
import AvatarForm from "./sections/AvatarForm"
import { useAppDispatch } from "../../hooks"
import { logout, updateEmail, updatePassword } from "../../../redux/slices/auth"
import BBDialog from "../dialog"

interface Props {
  user: UserDetails
  emailUpdated: boolean
  passwordUpdated: boolean
}

const MyAccountSettings: FC<Props> = ({
  user,
  emailUpdated,
  passwordUpdated
}) => {
  const dispatch = useAppDispatch()
  const [edittingSection, setEdittingSection] = useState<"info" | "password">()

  const handleClickEditInfo = () =>
    setEdittingSection(edittingSection === "info" ? undefined : "info")
  const handleClickChangePwd = () =>
    setEdittingSection(edittingSection === "password" ? undefined : "password")

  const handleUpdateEmail = (newEmail: string) =>
    dispatch(
      updateEmail({
        uid: user.id,
        email: newEmail
      })
    )

  const handleUpdatePassword = (newPassword: string) =>
    dispatch(
      updatePassword({
        uid: user.id,
        password: newPassword
      })
    )

  const handleConfirmDialog = () => {
    dispatch(logout())
  }

  return (
    <div className="px-6">
      <div className="font-bold text-xl py-6">My account settings</div>

      <div className="px-4">
        <AvatarForm info={user} />
        <MyAccountInfo
          info={user}
          inEditMode={edittingSection === "info"}
          toggleEdit={handleClickEditInfo}
          onUpdateEmail={handleUpdateEmail}
        />
        <PasswordForm
          inEditMode={edittingSection === "password"}
          toggleEdit={handleClickChangePwd}
          onUpdatePassword={handleUpdatePassword}
        />
        <OtherInfo info={user} />

        <BBDialog
          open={emailUpdated}
          title="Success"
          body="Your email has successfully been updated."
          okLabel="Confirm"
          onOk={handleConfirmDialog}
          onClose={handleConfirmDialog}
        />
        <BBDialog
          open={passwordUpdated}
          title="Success"
          body="Your password has successfully been updated."
          okLabel="Confirm"
          onOk={handleConfirmDialog}
          onClose={handleConfirmDialog}
        />
      </div>
    </div>
  )
}

export default MyAccountSettings
